import { render, staticRenderFns } from "./TextbookIssueMediaPage.vue?vue&type=template&id=1a18d4c4&"
import script from "./TextbookIssueMediaPage.vue?vue&type=script&lang=ts&"
export * from "./TextbookIssueMediaPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports